import React from 'react';
import { lastTenYears, violationsResponsability } from '../constants';
import { StyledTable, TableScroll } from './ViolationsTable.styles';

function ViolationsTable({ violationData }) {
  return (
    <TableScroll>
      <StyledTable>
        <thead>
          <tr>
            <th>Responsabilita</th>
            {lastTenYears.map((year) => (
              <th key={year.id}>{year.value}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {violationsResponsability.map((violation) => (
            <tr key={violation.id}>
              <th scope="row">{violation.name}</th>
              {violationData[violation.id].map((item, index) => (
                <td key={index}>{item.value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </TableScroll>
  );
}

export default ViolationsTable;
